import { Container } from 'ui/container'
import { ReferralsList } from 'features/admin/referrals'
import { Link } from 'react-router-dom'
import { routes } from 'core/routes/paths'

import c from '../assets/sass/page.module.scss'

const AdminReferralsPage = () => {
    return (
        <div className={c.component}>
            <div className={c.header}>
                <Link to={routes.admin} className={c.back}>
                    ← Назад
                </Link>
                <span className={c.title}>Реферальная система</span>
            </div>
            <Container>
                <ReferralsList />
            </Container>
        </div>
    )
}

export default AdminReferralsPage
